const getMonthYear = (dateObject) => {
  const month = dateObject.toLocaleString('default', { month: 'short' });
  const year = dateObject.getUTCFullYear();
  return `${month} ${year}`;
};
export default getMonthYear;
